import React from 'react';
import './styles.css';

export default class WhatWeDo extends React.Component {
  renderMember = member => {
    return (
      <div key={member.id} className="au-member-container">
        <div className="au-member-avatar-wrapper">
          <img className="au-member-avatar" src={member.avatar} alt={member.full_name} />
        </div>
        <div className="au-info-wrapper">
          <div>
            <p className="au-member-name">{member.full_name}</p>
            <p className="au-member-role">{member.role}</p>
          </div>
          <p className="au-member-description">{member.description}</p>
          <p className="au-member-description">{member.second_description}</p>
        </div>
      </div>
    );
  };

  render() {
    const {team} = this.props;
    return (
      <div className="au-our-team-container">
        <p className="invest-slogan">Our Team</p>
        <div className="au-members-container">
          {team.map(member => this.renderMember(member))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/informations/aboutUs/OurTeam.jsx